import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';

export const StyledProductTableOfInformationSection = styled.div`
  margin-bottom: ${rem(15)};

  table {
    thead {
      td:first-child {
        padding-left: 0;
      }
    }
  }
`;

export const StyledHtmlElement = styled.div`
  p {
    font-family: ${variables.fonts.fontGothamBook};
    font-size: ${rem(15)};
    line-height: ${rem(24)};
  }
`;

export const StyledHeadingTooltipContainer = styled.div`
  display: flex;
  align-items: center;
`;
